module.exports = __webpack_public_path__ + "img/tese.e963ca83.png";